import type { ErrorReporter, HttpFetcher, HttpFetcherOptions } from './http-fetcher';
import { createHttpFetcher as _createHttpFetcher } from './http-fetcher';

export type HttpFetcherWithBaseUrl = HttpFetcher<{ readonly baseUrl: URL }>;
export type { ErrorReportContext, ErrorReporter } from './http-fetcher';
export type HttpFetcherDependencies = {
    readonly errorReporter: ErrorReporter;
    readonly onRateLimited?: () => void;
};

export const createHttpFetcher = <T extends HttpFetcherOptions>(
    dependencies: HttpFetcherDependencies,
    options?: T,
): HttpFetcher<T> => {
    const { errorReporter, onRateLimited } = dependencies;

    return _createHttpFetcher({ errorReporter, fetch: globalThis.fetch.bind(globalThis), onRateLimited }, options);
};
